export const publishNotification = (type, message, dispatch) => {
  const notification = { type, message };
  dispatch('notification/add', notification, { root: true });
};
